import { httpRequest } from "../../http";

/**
 * The composition behind one side of a postcard, created on first open.
 *
 * A POST because it can create: a card made before postcards were editable has artwork and no
 * compositions, and the first person to open a side is the one who brings it into being. It is
 * idempotent -- a side that already has one gets it back untouched -- so calling it on every
 * open is correct rather than wasteful.
 */
export class CommandOpenMailPieceSide {
  async run(adId: number, side: "front" | "back") {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ads/${adId}/mail-piece/${side}/`;

    return await httpRequest<{ id: number; name: string; side: string }>(url, {
      method: "POST",
    });
  }
}
